import React, { createContext, useContext, useState } from "react";
import { translations, type Lang, type Translations } from "./translations";

type LangCtx = { lang: Lang; setLang: (l: Lang) => void; t: Translations };

const LanguageContext = createContext<LangCtx>({
  lang: "en",
  setLang: () => {},
  t: translations.en,
});

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const stored = localStorage.getItem("vereV-lang") as Lang | null;
  const [lang, setLangState] = useState<Lang>(stored ?? "en");

  const setLang = (l: Lang) => {
    setLangState(l);
    localStorage.setItem("vereV-lang", l);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
